import { gql } from '@apollo/client';

export const SignClinicalNote = gql`
  mutation SignClinicalNote($id: String!) {
    signClinicalNote(id: $id) {
      id
    }
  }
`;
